import { useEffect, useState } from "react";
import { renderQuarterTick } from "../../components/recharts/components";
import { ReMixChart } from "../../components/recharts/ReMixCharts";
import { ChartType } from "../../models/chart_model";
import { ExchangeColors } from "../Dashboard/Exchange3/FormatData";
import { CUMULATION_KEYS, Group_keys, units } from "./Data";
import {
  FormatChartData,
  FormatChartDataWithAverages,
} from "../../components/recharts/functions";
import { DmrcForecastedLoad } from "../../models/dmrc";
import FilterMenu from "../../components/FilterMenu";

export default function DmrcForecastChart({
  snapshots,
  selectedSlots,
  selectedStations,
}: {
  snapshots: DmrcForecastedLoad[];
  selectedSlots: {
    value: string;
    label: string;
  }[];
  selectedStations: {
    value: string;
    label: string;
  }[];
}) {
  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([]);
  const [selectedUnit, setSelectedUnit] = useState(units[0]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState<string[]>([]);
  const [selectedCumulation, setSelectedCumulation] = useState(
    CUMULATION_KEYS[0]
  );

  useEffect(() => {
    let formatedSnapshot = snapshots;
    if (selectedSlots.length > 0) {
      formatedSnapshot = snapshots.filter(
        (item: { time_slot: { toString: () => string } }) =>
          selectedSlots
            .map((item) => item.value)
            .includes(item.time_slot.toString())
      );
    }
    if (selectedStations.length > 0) {
      formatedSnapshot = snapshots.filter((item: { station__name: string }) =>
        selectedStations.map((item) => item.value).includes(item.station__name)
      );
    }
    if (selectedCumulation !== CUMULATION_KEYS[0]) {
      setSelectedUnit(units[1]);
    }
    const par = {
      keys: ["time_slot", "date"],
      groupBy: selectedGroupKeys.map((item) => item.key),
      aggregationKeys: ["demand_forecast_mwh", "demand_mw", "demand_mwh"],
      data: formatedSnapshot,
      volumeKey: "demand_forecast_mw",
      priceKey: "",
    };
    const cData =
      selectedCumulation === CUMULATION_KEYS[0]
        ? FormatChartDataWithAverages(par)
        : FormatChartData(par);
    setChartData(cData.data);
    setChartKeys(cData.keys);
  }, [
    selectedGroupKeys,
    snapshots,
    selectedSlots,
    selectedCumulation,
    selectedStations,
  ]);
  const _handleGroupByChange = (keyIndex: number) => {
    if (selectedGroupKeys.length != 0) {
      setSelectedGroupKeys([]);
    } else {
      setSelectedGroupKeys([Group_keys[keyIndex]]);
    }
  };
  const _handleUnitSelection = (unitIndex: number) => {
    if (selectedCumulation == CUMULATION_KEYS[1]) return;
    setSelectedUnit(units[unitIndex]);
  };

  const ForecastFilters = () => {
    return (
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Function"
          items={CUMULATION_KEYS.map((item) => item.label)}
          selectedItems={[selectedCumulation.label]}
          onSelect={(item, index) => {
            setSelectedCumulation(CUMULATION_KEYS[index]);
          }}
        />

        <FilterMenu
          title="Group By"
          items={Group_keys.map((item) => item.label)}
          selectedItems={selectedGroupKeys.map((item) => item.label)}
          onSelect={(item, index) => _handleGroupByChange(index)}
        />
        <FilterMenu
          title="Unit"
          items={units}
          selectedItems={[selectedUnit]}
          onSelect={(item, index) => {
            _handleUnitSelection(index);
          }}
        />
      </div>
    );
  };

  return (
    <div className="flex flex-row w-full h-full">
      <ForecastFilters />
      <div className="dmrc-chart">
        <div className="dmrc-chart-container">
          <ReMixChart
            chartContainerHeight="100vh"
            data={chartData}
            showSecondYAxis={true}
            isTimeSlot={true}
            onlyTitle={true}
            yAxisLabel={`Volume (${selectedUnit})`}
            rendexSecondXTick={renderQuarterTick}
            xaxisHeight={60}
            xAxisLabelOffset={17}
            secondXAxisHeight={35}
            unit={selectedUnit}
            showBrush={true}
            legendBreakIndex={chartKeys.length - 1}
            brushIndex={
              chartData.length > 96
                ? { startIndex: 0, endIndex: 95 }
                : {
                    startIndex: 0,
                    endIndex: chartData.length - 1,
                  }
            }
            legends={[
              ...chartKeys
                .map((key, index) => {
                  return {
                    dataKey:
                      key + "_demand_forecast_" + selectedUnit.toLowerCase(),
                    type: ChartType.Line,

                    name: key == "" ? "Forecast" : key + " Forecast",
                    stroke: ExchangeColors[index],
                    legendColor: ExchangeColors[index],
                    isDash: true,
                  };
                })
                .flat(),

              ...chartKeys
                .map((key, index) => {
                  return {
                    dataKey: key + "_demand_" + selectedUnit.toLowerCase(),
                    type: ChartType.Line,
                    name: key == "" ? "Actual" : key + " Actual",
                    stroke: ExchangeColors[index],
                    legendColor: ExchangeColors[index],
                  };
                })
                .flat(),
            ]}
            xDataKey="time_slot"
            secondXDataKey="date"
          />
        </div>
      </div>
    </div>
  );
}
